export default __webpack_public_path__ + "static/app-credit-174bfadd7287d129152d9b13323a64ee.jpg";